import request from '@/utils/request'
import setting from '@/settings'
import qs from 'qs'
const apiUrl = setting.apiUrl

/**
 * 获取常量字典列表
 * @param data
 */
export const getConstant = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/lboption/getConstant`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 *根据变量字典数据
 *
 * @param data
 * @returns {*}
 */
export const getOption = (data: any) => {
  return request({
    url: `${apiUrl.api}/lb/lboption/getOption`,
    method: 'post',
    data: qs.stringify(data)
  })
}

/**
 * 获取数据-通用
 * @param data
 */
export const getList = (data: any) => {
  return request({
    url: `${apiUrl.api}${data.url}`,
    method: 'post',
    data: qs.stringify(data.data)
  })
}

/**
 * 文件上传
 */
export const FileUpLoad = (data: any) => {
  return request({
    url: `${apiUrl.api}/core/oss/file/fileUploadPost`,
    method: 'post',
    data
  })
}

/**
 * 招生简章院校专业下拉框
 * @param data
 */
export const schoolSubjectComboBox = (data: any) => {
  return request({
    url: `${apiUrl.api}/lb/schoolSubject/schoolSubjectComboBox`,
    method: 'post',
    data: qs.stringify(data)
  })
}

/**
 * 代理类型下拉框
 * @param data
 */
export const getProxyType = (data: any) => {
  return request({
    url: `${apiUrl.api}/lb/user/proTypeList`,
    method: 'post',
    data: qs.stringify(data)
  })
}

/**
 * 根据院校id获取年级
 * @param data
 */
export const queryCriteriaGradeBySchoolId = (data: any) => {
  return request({
    url: `${apiUrl.api}/lb/grade/queryCriteriaGradeBySchoolId`,
    method: 'post',
    data: qs.stringify(data)
  })
}

/**
 * 获取树形代理类型
 * @param data
 */
export const getProStree = (data: any) => {
  return request({
    url: `${apiUrl.api}/lb/user/getProStree`,
    method: 'post',
    data: qs.stringify(data)
  })
}

/**
 * 合同到期提示信息列表
 * @param data
 */
export const userSubDeadlineTips = (data: any) => {
  return request({
    url: `${apiUrl.api}/lb/login/subDeadlineTips`,
    method: 'post',
    data: qs.stringify(data)
  })
}

/**
 * 合同到期提示信息
 * @param data
 */
export const userDeadlineTips = (data: any) => {
  return request({
    url: `${apiUrl.api}/lb/login/deadlineTips`,
    method: 'post',
    data: qs.stringify(data)
  })
}

/**
 * 获取民族
 * @param data
 */
export const nation = (data: any) => {
  return request({
    url: `${apiUrl.api}/lb/nation/search`,
    method: 'post',
    data: qs.stringify(data)
  })
}

/**
 *获取学习类型下拉
 *
 * @param data
 * @returns {*}
 */
export const getStudySelect = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/study/getStudySelect`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取所有业务
 * @param data
 */
export const getBusinessAll = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/business/getBusinessAll`,
    method: 'post',
    data: qs.stringify(data)
  })


/**
 * 下载文件
 * @param data
 */
export const fileDownPost = (data: any) =>
  request({
    url: `${apiUrl.api}/core/oss/file/fileDownPost`,
    method: 'post',
    data: qs.stringify(data)
  })
